import React from 'react';
import EmptyDataIcon from "../../../../assets/cms-icon-empty-files.svg";
import { messages } from '../../../../utils/language-en.json';
import EmptyData from '../../../Common/emptydata/emptyData';
import PositionsPayRateCard from './PositionsPayRateCard';

function PositionsPayRateList({ positions }) {
  return (
    <div className="PositionsPayRateList">
      <div className="row">
        { positions.length === 0
            ? <EmptyData
              type={"datatable"}
              icon={EmptyDataIcon}
              title={messages.emptydata.tableTitle}
              messsage={messages.emptydata.tableCopy}
            />
            : positions.map( (item, idx) => (
                <div className="col-sm-3" key={idx}>
                  <PositionsPayRateCard item={item} />
                </div>
              ) )
        }
      </div>
    </div>
  )
}

export default PositionsPayRateList
